import { Pipe } from '@angular/core';
import { isFunction } from '../helpers/helpers';
var IsFunctionPipe = (function () {
    function IsFunctionPipe() {
    }
    IsFunctionPipe.prototype.transform = function (input) {
        return isFunction(input);
    };
    IsFunctionPipe.decorators = [
        { type: Pipe, args: [{ name: 'isFunction' },] },
    ];
    /** @nocollapse */
    IsFunctionPipe.ctorParameters = function () { return []; };
    return IsFunctionPipe;
}());
export { IsFunctionPipe };
//# sourceMappingURL=is-function.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/boolean/is-function.js
// module id = 243
// module chunks = 4